import SeminarsList from './SeminarsList.container';

export default SeminarsList;
